module.exports = __webpack_public_path__ + "img/LoveYouGesture.4bc6fcfa.svg";